<template>
  <div class="simplebar" v-if="hasData">
      <div class="wrap">
        <div class="current-bar bar" :style="currentStyle">
          <span class="num">{{ data.compareNumber }}</span>
          <span class="text">{{ data.compareLabel }}</span>
        </div>
        <div class="total-bar bar" :style="totalStyle">
          <span class="num">{{ data.basicNumber }}</span>
          <span class="text">{{ data.basicLabel }}</span>
        </div>
      </div>
      <div class="title">{{ data.label }}</div>
      <span class="range" style="color: dodgerblue;" v-if="data.isRise">
      <i class="el-icon-sort-up"></i>&nbsp;
      <span>{{ data.percent }}%</span>
      </span>
        <span class="range" style="color: red;" v-else>
        <i class="el-icon-sort-down"></i>&nbsp;
        <span>{{ data.percent }}%</span>
      </span>
  </div>
  <show-no-data v-else></show-no-data>
</template>

<script>
  import ShowNoData from '../show-no-data'

  export default {
    components: {
      ShowNoData
    },
    name: 'compare-config',
    props: {
      data: {
        type: Object
      }
    },
    typeCode: '10',
    data() {
      return {
        heightRate: 1.5
      }
    },
    computed: {
      hasData: function () {
        return this.data.compareNumber > 0 && this.data.basicNumber > 0
      },
      currentStyle: function () {
        let zIndex = this.data.compareNumber > this.data.basicNumber ? 1 : 2
        return {
          height: this.data.compareNumber * this.heightRate + 'px',
          zIndex: zIndex
        }
      },
      totalStyle: function () {
        let zIndex = this.data.compareNumber > this.data.basicNumber ? 2 : 1
        return {
          height: this.data.basicNumber * this.heightRate + 'px',
          zIndex: zIndex
        }
      }
    }
  }
</script>

<style scoped>

  .current-bar {
    background-color: #475ec2;
  }

  .current-bar .num {
    color: white;
  }

  .current-bar .text {
    right: -58px;
    text-align: left;
  }

  .bar {
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 30px;
    margin-left: -15px;
    font-size: 12px;
    line-height: 30px;
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
    text-align: center;
  }

  .bar .num {
    display: block;
    font-weight: 600;
    text-align: center;
  }

  .bar .text {
    position: absolute;
    top: 0;
    width: 50px;
    color: #999;
    white-space: nowrap;
  }

  .total-bar {
    background-color: #88c9ee;
  }

  .total-bar .num {
    color: #222;
  }

  .total-bar .text {
    left: -58px;
    text-align: right;
  }

  .title {
    margin-top: 10px;
    margin-bottom: 5px;
    color: #222;
    line-height: 1;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    min-height: inherit!important;
  }

  .range {
    font-size: 12px;
  }

  .wrap {
    position: relative;
    height: 150px;
  }

  .simplebar {
    margin: 0 auto;
    padding: 50px 0 0;
    text-align: center;
    height: auto!important;
  }

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/compare-config.vue